import adminApi from "./admin";

export async function getAllGlossaries() {
	try {
		const res = await adminApi.get("/glossaries?sort=order&limit=0");

		return res.data.docs;
	} catch (error) {
		console.error(error);
		throw new Error("Erro ao buscar dados");
	}
}
